<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel1">{{data?.message}}</h4>
  <button type="button" class="close" (click)="closeModal()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" tabindex="12" ngbAutofocus>
  <form #transactionForm="ngForm">
    <div class="row">
      <div class="col-xl-2 col-md-8 col-12">
        <label for="count">Miktar <span *ngIf="product.productType">({{product.unitTypeName}})</span></label>
        <div class="form-group">
          <input type="number" class="form-control" id="count" name="count" [(ngModel)]="count"
            [disabled]="data?.kindId === 6 && isSerialProduct"
            (ngModelChange)="calculateTotalPrice(); allFieldsFilled()" />
        </div>
      </div>
      <div *ngIf="product.productType" [ngClass]="{
    'col-xl-8': data.kindId === 5 || data.kindId === 6,
    'col-xl-10': data.kindId !== 5 && data.kindId !== 6
    }" class="col-md-8 col-12">
        <label for="customSelect">Depo</label>
        <div class="form-group">
          <select class="form-control" id="customSelect" (change)="onWarehouseChange($event); allFieldsFilled()">
            <option *ngFor="let item of warehouses" [value]="item.warehouseId">
              {{ item.warehouseName }} ({{ getProductCountDifference(item.id) }})
            </option>
          </select>
        </div>
      </div>

      <div *ngIf="data?.kindId === 5 || data?.kindId === 6" class="mt-1 col-xl-2 col-md-2 col-12">
        <label>
          <input type="checkbox" [(ngModel)]="isSerialProduct" name="isSerialProduct" (change)="toggleSerialInput()" />
          Seri Nolu Ürün mü?
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4 col-md-8 col-12">
        <label for="salePrice">Satış Fiyatı</label>
        <div class="form-group">
          <div class="row">
            <div class="col-7 pr-0">
              <input type="number" class="form-control" id="salePrice" name="salePrice" [(ngModel)]="product.salePrice"
                (ngModelChange)="calculateTotalPrice(); allFieldsFilled(); calculatePriceDifferencePercentage();" />
            </div>
            <div class="col-5 pl-0">
              <select class="form-control" id="currencySelect" (change)="onCurrencySelect($event); allFieldsFilled();">
                <option *ngFor="let item of currencies" [value]="item.id" [selected]="product.currencyId == item.id">
                  {{item.currencyName}}
                </option>
              </select>
            </div>
          </div>
          <strong style="display: flex; text-align: center;">A.f ({{purchasePrice}}{{product.currencyName}}) -
            %{{priceDifferencePercentage.toFixed(0)}}</strong>
        </div>
      </div>
      <div class="col-xl-2 col-md-8 col-12">
        <label for="saleTaxId">Kdv</label>
        <div class="form-group">
          <select class="form-control" id="saleTaxId" (change)="onSaleTaxChange($event)">
            <option *ngFor="let item of allTax" [value]="item.id" [selected]="product.saleTaxId == item.id">
              {{ item.taxRate }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-xl-3 col-md-8 col-12">
        <label for="discountRate">İskonto</label>
        <div class="form-group">
          <div class="input-group">
            <input type="number" class="form-control" id="discountRate" name="discountRate" [(ngModel)]="discountRate"
              (ngModelChange)="calculateTotalPrice(); allFieldsFilled()" />
            <div class="input-group-append">
              <span class="input-group-text">%</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-8 col-12">
        <label for="total">Toplam</label>
        <div class="form-group">
          <input type="text" class="form-control" id="total" name="total" [(ngModel)]="total"
            (ngModelChange)="calculateSalePriceFromTotal(); allFieldsFilled()" />
        </div>
      </div>
    </div>

    <div class="row mt-2 d-flex">
      <!-- <ng-template #hideSection></ng-template>

      <ng-container *ngIf="product.typeName !== 'Hizmet'; else hideSection">
        <div class="feature-item col-xl-3 col-md-6 col-sm-12" *ngFor="let item of features">
          <ng-template [ngIf]="!product.productType">
            <label>{{ item.name }}</label>
            <select class="form-control" [(ngModel)]="item.value" name="feature-{{ item.id }}"
              (change)="updateSelectedFeatures()">
              <option [value]="true">Evet</option>
              <option [value]="false">Hayır</option>
            </select>
          </ng-template>
        </div>
      </ng-container> -->

      <!-- Product Variant Section -->
      <div class="row mt-1 col-12" *ngIf="allVariants?.length">
        <div *ngFor="let variant of allVariants" [ngClass]=" variant.variantType===3 ? 'col-xl-4 col-md-6 col-sm-12'
          : 'col-xl-4 col-md-6 col-sm-12'">

          <div class="d-flex align-items-center mb-50">
            <i class="feather"
              [ngClass]="variant.displayType === 3 || variant.displayType === 2 ? 'icon-eye' : 'icon-eye-off'"
              (click)="variant.displayType = (variant.displayType === 3 || variant.displayType === 2) ? 1 : 2"
              style="cursor: pointer;" title="Tabloda gözükmesini istiyorsan aktif bırak"></i>

            <label class="fw-bold mb-0 ml-25">
              {{ variant.name }}
            </label>

          </div>

          <!-- <div class="d-flex align-items-center mb-50">
            <input type="checkbox" [(ngModel)]="variant.displayType" [ngModelOptions]="{standalone: true}"
              (change)="variant.displayType = variant.displayType ? 3 : 1" />
            <span class="ml-1">Gözüksün mü?</span>
          </div> -->
          <div>
            <!-- <label class="fw-bold">{{ variant.name }}</label> -->
            <!-- 1 → Select -->
            <ng-container *ngIf="variant.variantType === 1">
              <select class="form-control" [(ngModel)]="variant.selectedOptionId"
                (ngModelChange)="checkRequiredVariantsFilled()" [ngModelOptions]="{standalone: true}">
                <option *ngFor="let opt of variant.productVariantOptions" [value]="opt.id">
                  {{ opt.name }}
                </option>
              </select>
            </ng-container>

            <!-- 2 → Checkbox -->
            <ng-container *ngIf="variant.variantType === 2">
              <!--  <div class="form-check">
                <input type="checkbox" class="form-check-input" [(ngModel)]="variant.valueBool"
                  (ngModelChange)="checkRequiredVariantsFilled()" [ngModelOptions]="{standalone: true}" />
                <label class="form-check-label">Evet / Hayır</label>
              </div> -->

              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="customCheck1" [(ngModel)]="variant.valueBool"
                  (ngModelChange)="checkRequiredVariantsFilled()" [ngModelOptions]="{standalone: true}" />
                <label class="custom-control-label" for="customCheck1">Evet / Hayır</label>
              </div>

              <div *ngIf="variant.valueBool && variant.trueLabel" class="text-success small">
                ({{ variant.trueLabel }})
              </div>
              <div *ngIf="!variant.valueBool && variant.falseLabel" class="text-danger small">
                ({{ variant.falseLabel }})
              </div>
            </ng-container>

            <!-- 3 → Input -->
            <ng-container *ngIf="variant.variantType === 3">
              <input type="text" class="form-control" [(ngModel)]="variant.valueText"
                (ngModelChange)="checkRequiredVariantsFilled()" [ngModelOptions]="{standalone: true}"
                placeholder="Değer giriniz..." />
            </ng-container>
          </div>
        </div>
      </div>

      <div class="col-xl-6 col-md-12 col-sm-12 mt-1"
        [ngClass]="product.productType ? 'col-xl-12 col-md-12 col-sm-12' : 'col-xl-6 col-md-12 col-sm-12'">
        <label for="description">Açıklama</label>
        <div class="form-group">
          <input type="text" class="form-control" id="description" name="description" [(ngModel)]="description" />
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-xl-12 col-md-12 col-12">
        <h5>Özellikler</h5>
        <div *ngFor="let feature of features" class="form-check">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" [id]="'feature-' + feature.id"
              [(ngModel)]="feature.isChecked" [ngModelOptions]="{ standalone: true }"
              (change)="updateSelectedFeatures()" />
            <label class="custom-control-label" [for]="'feature-' + feature.id">{{ feature.name }} </label>
          </div>
        </div>
      </div>
    </div> -->

    <div class="row mt-2">

    </div>
    <!-- Seri Numara Input Alanları -->
    <div *ngIf="isSerialProduct && count > 0 && data?.kindId === 5">
      <h5>Seri Numara Girişi</h5>
      <div *ngFor="let serial of serialNumbers; let i = index; trackBy: trackByIndex" class="form-group">
        <label for="serial-{{i}}">Seri No {{i + 1}}</label>
        <input type="text" id="serial-{{i}}" class="form-control" [(ngModel)]="serialNumbers[i]"
          (focus)="preventFocusLoss(i)" name="serial-{{i}}" />
      </div>
    </div>
    <div class="col-12" *ngIf="data?.kindId === 6 && isSerialProduct && product.serials.length > 0">
      <h4>Seri Numaraları</h4>
      <table class="table table-responsive">
        <thead>
          <tr>
            <th>#</th>
            <th>Seri No</th>
            <th>Durum</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let seri of product.serials; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ seri.serialNo }}</td>
            <td>
              <input type="checkbox" [checked]="saleSeriNo.includes(seri.id)" (change)="updateSelectedSerials(seri)"
                name="seriId-{{i}}" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
  <div *ngIf="product.subProducts?.length > 0" style="width: 100%;">
    <h4>Alt Ürünler</h4>
    <table class="table table-responsive" style="width: 100%;">
      <thead>
        <tr>
          <th>#</th>
          <th>Ürün Adı</th>
          <th>Adet</th>
          <th>Satış Fiyatı</th>
          <th>Satış Vergi</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let subProduct of product.subProducts; let i = index">
          <td>{{i+1}}</td>
          <td> {{subProduct.name | slice:0:20}}{{ subProduct.name.length > 20 ? '...'
            : '' }} </td>
          <td> {{subProduct.count ?? 'Yok'}} </td>
          <td> {{subProduct.salePrice ?? 'Yok'}} </td>
          <td> {{subProduct.saleTax ?? 'Yok'}} </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="closeModal()" rippleEffect>
    İptal
  </button>
  <button type="button" class="btn btn-success" rippleEffect (click)="addTransaction()"
    [disabled]="!allFieldsFilled() || (data?.kindId === 5 && !isAllSerialNumbersFilled()) || !requiredVariantsFilled"
    *ngIf="data?.transactionId == null">
    Kaydet
  </button>
  <button type="button" class="btn btn-success" rippleEffect (click)="addTransactionProduct()"
    [disabled]="!allFieldsFilled()" *ngIf="data?.transactionId!=null">
    Kaydet
  </button>
</div>